/*
 * Copyright (c) 2022. American Express Company
 */

// third party
import React, { Component, ReactComponentElement } from 'react';
import { FieldControl, Label } from '@americanexpress/dls-react';

// models and services
import LiteralsService from '../../services/literals/LiteralsService';

// components
import BWCurrencyInput from 'src/bw/bw-currency-input/BW-Currency-Input';
import GoalDrawer from './GoalDrawer';
import InfoCallout from 'src/components/callout/InfoCallout';

// icons and styles
import { ReactComponent as MoneyBagIcon } from 'src/bw/goal/money-bag.svg';
import { ReactComponent as WillIcon } from 'src/bw/goal/will.svg';
import styles from 'src/components/formik-fields/currency-input/CurrencyInput.module.scss';

export default class WindfallDrawer extends Component<any, any> {
    public override render(): ReactComponentElement<any> {
        const drawerProps: any = this.props.drawerProps;

        let icon: JSX.Element = null;
        let howMuch: string;

        switch (drawerProps.card.description) {
            case 'windfall':
                icon = <MoneyBagIcon />;
                howMuch = LiteralsService.getLiteral('WindfallDrawer.windfall.howMuch');
                break;

            case 'receive inheritance':
                icon = <WillIcon />;
                howMuch = LiteralsService.getLiteral('WindfallDrawer.inheritance.howMuch');
                break;
        }

        return (
            <GoalDrawer
                drawerProps={drawerProps}
                handleBack={this.props.handleBack}
                icon={icon}
                introContent={<span>NEEDS INTRO CONTENT</span>}
                handleUpdateCard={this.props.handleUpdateCard}
                handleChangeCard={this.props.handleChangeCard}
                handleDeleteCard={this.props.handleDeleteCard}
                showLoader={this.props.showLoader}
                hideLoader={this.props.hideLoader}
                cashFlow={this.props.user.cashFlow}
                handleChangeCardDate={this.props.handleChangeCardDate.bind(this)}
                startDateLabel="Planned date"
            >
                <FieldControl>
                    <Label htmlFor="delta">{howMuch}</Label>
                    <BWCurrencyInput
                        fullWidth
                        id="delta"
                        defaultValue={0}
                        value={drawerProps.card.attributes.transactionAmount}
                        showFractions={false}
                        onChange={(value: number) => {
                            this.props.handleChangeCardAttribute(drawerProps.card, value, 'transactionAmount');
                        }}
                    />
                    <InfoCallout
                        className={styles.currencyInputInfoCallout}
                        text={LiteralsService.getLiteral('WindfallDrawer.afterTax')}
                        noMargin
                    />
                </FieldControl>
            </GoalDrawer>
        );
    }
}
